export const FETCH_SEARCH_RESULTS = 'FETCH_SEARCH_RESULTS';
export const FETCH_AUTOCOMPLETE = 'FETCH_AUTOCOMPLETE';
export const FETCH_SIDE_EFFECTS = 'FETCH_SIDE_EFFECTS';

export const SET_USER = 'SET_USER';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER = 'UPDATE_USER';

export const SUBSCRIBE = 'SUBSCRIBE';

export const ADD_INVENTORY = 'ADD_INVENTORY';
export const FETCH_INVENTORY = 'FETCH_INVENTORY';
export const UPDATE_INVENTORY = 'UPDATE_INVENTORY';
export const DELETE_INVENTORY = 'DELETE_INVENTORY';


export const FETCH_NOTIFICATION_UNREAD_COUNT = 'FETCH_NOTIFICATION_UNREAD_COUNT';
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ';
export const MARK_NOTIFICATION_UNREAD = 'MARK_NOTIFICATION_UNREAD';

export const FETCH_DASHBOARD_SUMMARY = 'FETCH_DASHBOARD_SUMMARY';

export const APP_LOGOUT = 'APP_LOGOUT';

export const ADD_SALE = 'ADD_SALE';
export const FETCH_SALES = 'FETCH_SALES';

export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';


export const ACCESS_LOADING = 'ACCESS_LOADING';
export const ACCESS_SUCCESS = 'ACCESS_SUCCESS';
export const ACCESS_FAIL = 'ACCESS_FAIL';
export const ACCESS_RESET = 'ACCESS_RESET';